import React from 'react';
export function ServiceDetails() {
  return <section className="py-16 bg-gray-50" data-id="element-311">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-312">
        {/* Setup & Training */}
        <div id="setup-training" className="flex flex-col md:flex-row items-center mb-20 pt-16 -mt-16" data-id="element-313">
          <div className="md:w-1/2 mb-8 md:mb-0 md:pr-12" data-id="element-314">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uwKBvDz4qhnZiyYZYn3Km8/Setup_Image.png" alt="Startup bookkeeping setup and training" className="rounded-lg shadow-lg w-full h-auto" data-id="element-315" />
          </div>
          <div className="md:w-1/2" data-id="element-316">
            <h3 className="text-2xl md:text-3xl font-bold text-[#3A4A46] mb-4" data-id="element-317">
              Setup & Training
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-318">
              I'll get everything set up for your business, organize your
              accounts, and show you how to use it-step by step. No stress, just
              a smooth start so you can feel confident with your books.
            </p>
            <ul className="space-y-3 mb-6" data-id="element-319">
              <li className="flex items-start" data-id="element-320">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-321">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-322">
                  QuickBooks® software setup and configuration
                </span>
              </li>
              <li className="flex items-start" data-id="element-323">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-324">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-325">
                  Chart of accounts customization
                </span>
              </li>
              <li className="flex items-start" data-id="element-326">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-327">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-328">
                  Training on bookkeeping best practices
                </span>
              </li>
              <li className="flex items-start" data-id="element-329">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-330">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-331">
                  Lender-ready financial setup
                </span>
              </li>
            </ul>
            <p className="font-medium text-[#3A4A46] mb-6" data-id="element-332">
              Starting at $500 one-time setup
            </p>
            <a href="https://outlook.office.com/book/MeyerBookkeepingTax@meyerbkt.com/" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#3A4A46] text-white px-5 py-2 rounded hover:bg-[#8A9A5B] transition-colors" data-id="element-333">
              Let's Talk
            </a>
          </div>
        </div>
        {/* Catch-up Bookkeeping */}
        <div id="catchup-bookkeeping" className="flex flex-col-reverse md:flex-row items-center mb-20 pt-16 -mt-16" data-id="element-334">
          <div className="md:w-1/2 md:pr-12" data-id="element-335">
            <h3 className="text-2xl md:text-3xl font-bold text-[#3A4A46] mb-4" data-id="element-336">
              Catch-Up Bookkeeping
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-337">
              If you're behind on your books, you're not alone - most business
              owners are. I can help you catch up, clean up, and move forward
              with peace of mind (and accurate numbers).
            </p>
            <ul className="space-y-3 mb-6" data-id="element-338">
              <li className="flex items-start" data-id="element-339">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-340">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-341">
                  Reconcile bank and credit card accounts
                </span>
              </li>
              <li className="flex items-start" data-id="element-342">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-343">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-344">
                  Categorize income and expenses
                </span>
              </li>
              <li className="flex items-start" data-id="element-345">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-346">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-347">
                  Clean up your accounting system
                </span>
              </li>
              <li className="flex items-start" data-id="element-348">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-349">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-350">
                  Prepare financial statements
                </span>
              </li>
            </ul>
            <p className="font-medium text-[#3A4A46] mb-6" data-id="element-351">
              Starting at $100 per month of backlog
            </p>
            <a href="https://outlook.office.com/book/MeyerBookkeepingTax@meyerbkt.com/" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#3A4A46] text-white px-5 py-2 rounded hover:bg-[#8A9A5B] transition-colors" data-id="element-352">
              Let's Talk
            </a>
          </div>
          <div className="md:w-1/2 mb-8 md:mb-0" data-id="element-353">
            <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1500&q=80" alt="Catching up on bookkeeping" className="rounded-lg shadow-lg w-full h-auto" data-id="element-354" />
          </div>
        </div>
        {/* Monthly Bookkeeping */}
        <div id="monthly-bookkeeping" className="flex flex-col md:flex-row items-center mb-20 pt-16 -mt-16" data-id="element-355">
          <div className="md:w-1/2 mb-8 md:mb-0 md:pr-12" data-id="element-356">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i4odmiHQWB1V9mN9pExEEL/Monthly_Bookkeeping.png" alt="Monthly bookkeeping services" className="rounded-lg shadow-lg w-full h-auto" data-id="element-357" />
          </div>
          <div className="md:w-1/2" data-id="element-358">
            <h3 className="text-2xl md:text-3xl font-bold text-[#3A4A46] mb-4" data-id="element-359">
              Monthly Bookkeeping
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-360">
              Ongoing support to maintain accurate financial records, ensuring
              your business stays compliant and you have the insights needed for
              smart decisions.
            </p>
            <ul className="space-y-3 mb-6" data-id="element-361">
              <li className="flex items-start" data-id="element-362">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-363">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-364">
                  Monthly bank and credit card reconciliation
                </span>
              </li>
              <li className="flex items-start" data-id="element-365">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-366">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-367">
                  Income and expense categorization
                </span>
              </li>
              <li className="flex items-start" data-id="element-368">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-369">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-370">
                  Monthly financial statements
                </span>
              </li>
              <li className="flex items-start" data-id="element-371">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-372">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-373">
                  Payroll and sales tax add-ons
                </span>
              </li>
            </ul>
            <p className="font-medium text-[#3A4A46] mb-6" data-id="element-374">
              Starting at $200 per month
            </p>
            <a href="https://outlook.office.com/book/MeyerBookkeepingTax@meyerbkt.com/" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#3A4A46] text-white px-5 py-2 rounded hover:bg-[#8A9A5B] transition-colors" data-id="element-375">
              Let's Talk
            </a>
          </div>
        </div>
        {/* Tax Preparation */}
        <div id="tax-preparation" className="flex flex-col-reverse md:flex-row items-center pt-16 -mt-16" data-id="element-376">
          <div className="md:w-1/2 md:pr-12" data-id="element-377">
            <h3 className="text-2xl md:text-3xl font-bold text-[#3A4A46] mb-4" data-id="element-378">
              Tax Preparation
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-379">
              Professional tax preparation for individuals and small businesses.
              Let me help you navigate the tax code, maximize deductions, and
              ensure compliance with all regulations.
            </p>
            <ul className="space-y-3 mb-6" data-id="element-380">
              <li className="flex items-start" data-id="element-381">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-382">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-383">Personal tax returns</span>
              </li>
              <li className="flex items-start" data-id="element-384">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-385">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-386">
                  Small business tax returns
                </span>
              </li>
              <li className="flex items-start" data-id="element-387">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-388">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-389">Electronic filing</span>
              </li>
              <li className="flex items-start" data-id="element-390">
                <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#8A9A5B] text-white mr-3 flex-shrink-0" data-id="element-391">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-392">Client portal access</span>
              </li>
            </ul>
            <p className="font-medium text-[#3A4A46] mb-6" data-id="element-393">Starting at $200</p>
            <a href="/tax-preparation" className="inline-block bg-[#3A4A46] text-white px-5 py-2 rounded hover:bg-[#8A9A5B] transition-colors" data-id="element-394">
              Learn More
            </a>
          </div>
          <div className="md:w-1/2 mb-8 md:mb-0" data-id="element-395">
            <img src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1500&q=80" alt="Tax preparation services" className="rounded-lg shadow-lg w-full h-auto" data-id="element-396" />
          </div>
        </div>
      </div>
    </section>;
}